import { useTranslation } from 'react-i18next';
import DashboardWidgetCard from '../../DashboardWidgetCard';
import MasterContent from './MasterContent';

const MasterStatus = () => {
  const { t } = useTranslation();
  const title = t('masters-import.dashboard.title');

  return (
    <DashboardWidgetCard title={title}>
      <MasterContent />
    </DashboardWidgetCard>
  );
};

export default MasterStatus;
